module.exports = __webpack_public_path__ + "static/media/euro.48b9d1ec.png";